import React from 'react';
import './Stats.css';

const STATS = [
  { number: '500+', label: 'Events Delivered'  },
  { number: '50+',  label: 'Healthcare Brands' },
  { number: '3+',  label: 'Years of Expertise' },
  { number: '15+',  label: 'Therapy Areas'     },
];

function Stats() {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats__grid">
          {STATS.map(({ number, label }) => (
            <div className="stats__card reveal" key={label}>
              <span className="stats__number">{number}</span>
              <span className="stats__label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
